import { Component } from '@angular/core'

@Component({
    selector: 'app-registrations',
    templateUrl: './registrations.component.html',
})
export class RegistrationsComponent {}
